import Vue from 'vue';
import 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/code';
import 'tinymce/skins/ui/oxide/skin.min.css';
// @ts-ignore
import Editor from '@tinymce/tinymce-vue';
import cleanPastedHtml from './cleanPastedHtml';

// Content is mostly pasted from Claude, ChatGPT, emails or Word. Those bring
// wrapper divs/sections, framework comments, classes and data-* attributes that
// break the article layout (e.g. the theme pads every <section> by 96px).
// Only the markup below survives; disallowed tags are unwrapped, their text kept.
const validElements = [
  'p[style]', 'br', 'strong/b', 'em/i', 'u', 'sup', 'sub', 'hr',
  'a[href|target|rel|title]', 'img[src|alt|width|height]',
  'h2[style]', 'h3[style]', 'h4[style]', 'h5[style]', 'h6[style]',
  'ul[style]', 'ol[style]', 'li', 'dl', 'dt', 'dd', 'blockquote', 'figure', 'figcaption',
  'table[border|width|cellpadding|cellspacing|style]', 'caption', 'thead', 'tbody', 'tfoot', 'tr[style]',
  'th[colspan|rowspan|scope|style]', 'td[colspan|rowspan|scope|style]',
].join(',');

const validStyles = {
  '*': 'text-align',
  'ul': 'list-style-type',
  'ol': 'list-style-type',
  'table': 'width,height,border-collapse,float,margin-left,margin-right',
  'tr': 'height',
  'td': 'width,height,vertical-align',
  'th': 'width,height,vertical-align',
};

const defaults = {
  skin: false,
  content_css: false,
  plugins: 'paste link lists table image code',
  toolbar: 'undo redo | formatselect | bold italic underline | link image | bullist numlist | table | code',
  block_formats: 'Absatz=p; Überschrift 2=h2; Überschrift 3=h3; Überschrift 4=h4; Überschrift 5=h5; Überschrift 6=h6',
  valid_elements: validElements,
  valid_styles: validStyles,
  // The UI must not offer markup the whitelist strips again on save:
  // TinyMCE 5 underlines with a styled <span>; the menubar and the advanced
  // table tabs offer colours, fonts and borders.
  formats: { underline: { inline: 'u', exact: true } },
  menubar: false,
  table_advtab: false,
  table_cell_advtab: false,
  table_row_advtab: false,
  // The paste plugin filters before insertContent, so it needs its own hook.
  paste_preprocess: (_: any, args: any) => {
    args.content = cleanPastedHtml(args.content);
  },
  // Covers loading stored content and the code view.
  // Raw content comes from TinyMCE itself (undo levels) and must stay untouched.
  setup: (editor: any) => {
    editor.on('BeforeSetContent', (e: any) => {
      if (typeof e.content === 'string' && e.format !== 'raw') {
        e.content = cleanPastedHtml(e.content);
      }
    });
  },
};

Vue.component('tinymce', {
  functional: true,
  render(h: any, ctx: any) {
    const props = { ...ctx.props, init: { ...defaults, ...ctx.props.init } };
    return h(Editor, { ...ctx.data, props }, ctx.children);
  },
});
